// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1LerI","empty":"ModalGraph_empty__1LffH"};